import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweet } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweet';
import type { GetTweets200PageAllOfThreeContentItemReferencedTweetType } from './getTweets200PageAllOfThreeContentItemReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type GetTweets200PageAllOfThreeContentItemReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweet;
  type?: GetTweets200PageAllOfThreeContentItemReferencedTweetType;
};
